import React from "react";
import {gridConstants} from "./";

interface GridFlexSpacerProps {
    children?: React.ReactNode;
}

export const GridFlexSpacer: React.FC<GridFlexSpacerProps> = ({ children }: GridFlexSpacerProps) => {
    const hideForPrintClass = (!children) ? "hidden-print" : "";

    return <div className={`${gridConstants.class.CELL} ${gridConstants.column.AUTO} ${hideForPrintClass}`}>{children}</div>;
};
